import { ArrowUpIcon } from 'assets/svgs';
import { useState, useEffect } from 'react';

const TopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 z-[500] rounded-full bg-gray-300 p-3 shadow-sm duration-300 hover:bg-slate-400 focus:outline-none"
          aria-label="Scroll to top"
        >
          <ArrowUpIcon className="h-6 w-6 transition-colors duration-300 hover:text-white" />
        </button>
      )}
    </>
  );
};

export default TopButton;